import React from 'react'
import { Button, Modal } from 'antd'
import {CloseIco, ModalCloseIco} from '../../../modules/CustomIcons'

import './index.scss'
import {Scrollbar} from "smooth-scrollbar-react";


const LimitsModal: React.FC<any> = (props) => {
    return (
        <div className='notificationWarningModal'>
            <Modal
                okText={props.okText}
                okButtonProps={{style: {background: '#015CD1'}}}
                title={props.data.modalTitle}
                centered
                open={props.visible}
                onOk={props.onOk}
                closeIcon = {<div className={'close-limit-icon'}><Button icon={<ModalCloseIco />}/></div>}
                onCancel={props.onCancel}
                okType='primary'
                width={700}
                height = {670}
                className={props.className}
                cancelButtonProps={{ style: { display: 'none' } }}
                footer={props.footer}
            >
                <Scrollbar>

                    <div style={{textAlign:"center"}}>
                        <p>{ props.data?.icon}</p>
                        {props.data.type === 'success'? <p style={{fontSize:'18px',color:'#223142'}}>{props.data.note}</p>:
                            <p style={{fontSize:'18px',color:'#F3646C'}}>{props.data.note}</p>
                        }

                    </div>
                    {
                        props.data?.groups.map((row:any)=>{
                            return(
                                <div >

                                    <table style={{width:'100%'}}
                                    className={'has_border_bottom'}>
                                    <tbody>
                                    {row.title && (
                                        <tr>
                                            <td style={{textAlign:"center",fontSize:'18px',color:'#223142'}}>
                                                {row.title}
                                            </td>
                                        </tr>
                                    )}
                                    {
                                        row.data?.map((line:any)=>{
                                            return(
                                                line !== undefined ?
                                                    <tr style={{display:"flex",justifyContent:"space-between",margin: '10px',
                                                        borderBottom: '1px solid #D9E3EC'}}>
                                                        <td style={{fontSize:'14px',fontWeight:'400',
                                                            color:'#747A83'}}>{line.label}</td>
                                                        <td style={{color:'#223142',fontSize:'14px',fontWeight:'400'}}>{line.value}</td>
                                                    </tr> :<></>
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>
                                </div>

                            )
                        })
                    }
                </Scrollbar>
            </Modal>
        </div>
    )
}

export default LimitsModal
